import React from "react";

export default function Modal({ open, onClose, title, children, footer, testId }) {
  if (!open) return null;
  return (
    <div className="modal-backdrop" onClick={onClose} data-testid={`${testId}-backdrop`}>
      <div
        className="modal-panel p-6 md:p-8"
        onClick={(e) => e.stopPropagation()}
        data-testid={testId}
      >
        <div className="flex items-center justify-between mb-5">
          <h3 className="font-heebo font-bold text-xl text-slate-900">{title}</h3>
          <button
            onClick={onClose}
            className="btn-ghost"
            data-testid={`${testId}-close`}
            aria-label="סגור"
          >
            סגור ✕
          </button>
        </div>
        <div>{children}</div>
        {footer && <div className="mt-6 flex gap-3 justify-start">{footer}</div>}
      </div>
    </div>
  );
}
